import React from 'react';
import {useTranslation} from 'react-i18next';
import {Check, Minus, Question} from '../../icons';

const EFFECTS = [
    ['dashboard', 'alerts_center.rules.effect_dashboard'],
    ['email', 'alerts_center.rules.effect_email'],
    ['webhook', 'alerts_center.rules.effect_webhook'],
    ['bitacora', 'alerts_center.rules.effect_bitacora'],
];

/**
 * Los rótulos Tablero · Correo · Webhook · Bitácora de una regla, con el estado REAL de cada camino
 * en el cartel (`systemEffects` / `customEffects`): «te llega», «lo tienes apagado en Mis alertas»,
 * «evento apagado en el webhook»… Es lo que la pantalla clásica no decía: el switch prometía un
 * correo que la mitad de las alertas no manda.
 *
 * El cartel se ancla a la fila de rótulos y no a cada rótulo (receta del ANCLA de `ui-estilos.md`):
 * anclado al último, a 390 se salía por la derecha.
 *
 * Una regla que sólo pinta muestra los cuatro, con Correo, Webhook y Bitácora apagados: así se ve que
 * existen y que esta regla no los usa (fede, 09/10). Un rótulo aparte, «Sólo pinta el Tablero», se leía
 * como otro camino al lado de «Tablero».
 */
export function RuleEffects({effects}) {
    const {t} = useTranslation();
    return (
        <div className="alc-effects">
            {EFFECTS.map(([key, labelKey]) => {
                const effect = effects[key];
                const label = t(labelKey);
                const tip = t(effect.tipKey);
                const agency = effect.agency
                    ? t('alerts_center.rules.effect_email_agency', {enabled: effect.agency.enabled, total: effect.agency.total})
                    : null;
                // `-unknown`: no se pudo saber (el webhook no respondió): ni «sale» ni «no sale».
                const state = effect.on ? ' -on' : (effect.unknown ? ' -unknown' : ' -off');
                return (
                    <span key={key} tabIndex={0} data-effect={key} role="img"
                          className={`info-icon-container alc-effect${state}`}
                          aria-label={`${label}: ${tip}${agency ? ` ${agency}` : ''}`}>
                        {effect.on && <Check size={11} weight="bold" aria-hidden="true"/>}
                        {!effect.on && effect.unknown && <Question size={11} weight="bold" aria-hidden="true"/>}
                        {!effect.on && !effect.unknown && <Minus size={11} weight="bold" aria-hidden="true"/>}
                        {label}
                        <span className="warning-tooltip alc-effect__tip" aria-hidden="true">
                            <span className="warning-tooltip-body">
                                <span className="warning-tooltip-text">{tip}</span>
                                {agency && <span className="warning-tooltip-text alc-effect__extra">{agency}</span>}
                            </span>
                        </span>
                    </span>
                );
            })}
        </div>
    );
}
